import { VegaInput } from '@globalpayments/vega-react';

interface Props {
  searchVal: string;
  filterValues: (searchVal: string) => void;
}

const SearchBar: React.FC<Props> = ({ searchVal, filterValues }) => {
  return (
    <VegaInput
      label="Filter session activity"
      maxLength={100}
      onVegaChange={(event) => filterValues(event.detail)}
      prefixIcon="fa-solid fa-magnifying-glass"
      showClearIcon
      value={searchVal}
      valueUpdateTrigger="input"
    />
  );
};

export default SearchBar;